import { render, staticRenderFns } from "./InboxThread.vue?vue&type=template&id=59413a2e&scoped=true"
import script from "./InboxThread.vue?vue&type=script&lang=js"
export * from "./InboxThread.vue?vue&type=script&lang=js"
import style0 from "./InboxThread.vue?vue&type=style&index=0&id=59413a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59413a2e",
  null
  
)

export default component.exports